export function isDuplicateAddById(
  input: string,
  selectedSpaceIds: string[],
  originalSpaceIds: Set<string>,
  idAddedSpaceIds: Set<string>,
  addedByIdInputs: Set<string>,
): boolean {
  return (
    selectedSpaceIds.includes(input) ||
    originalSpaceIds.has(input) ||
    idAddedSpaceIds.has(input) ||
    addedByIdInputs.has(input)
  );
}
